import { RemoteLoadMissionAnswers } from '../../../data/usecases/mission-answer/remote-get-mission-answer'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makePostMissionAnswerImages = (uuid:string): RemoteLoadMissionAnswers => {
  return new RemoteLoadMissionAnswers(`/public/mission_answers/pictures?game=${uuid}`, makeAxiosHttpClient())
}
